import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

const ShowHideButton = ({
  children,
  buttonText,
  displayChildrenOnlyOnTablet,
  displayChildrenOnlyOnMobile,
  displayAlertOnlyOnMobile,
}) => {
  const intl = useIntl();
  const [showChildren, setShowChildren] = useState(false);

  const toggleButton = () => {
    setShowChildren(!showChildren);
  };

  let renderChildren = showChildren ? children : null;

  let renderButtonText = showChildren
    ? intl.formatMessage
      ? intl.formatMessage({ id: 'graph.hide', defaultMessage: 'Hide' }) +
        buttonText
      : 'Hide' + buttonText
    : intl.formatMessage
    ? intl.formatMessage({ id: 'graph.show', defaultMessage: 'Show' }) +
      buttonText
    : 'Show' + buttonText;

  let button = (
    <button
      type="button"
      className="btn"
      onClick={toggleButton}
      style={{
        border: '1px solid #008743',
        margin: '25px 5px 10px 0',
        fontWeight: '400',
        color: '#008743',
        padding: '10px 35px',
        fontSize: '0.85rem',
        backgroundColor: '#ffffff',
      }}
    >
      {renderButtonText}
    </button>
  );

  let desktopClasses = 'show-full-list-container d-none d-md-block';
  let mobileClasses = 'd-block d-md-none';
  if (displayChildrenOnlyOnTablet) {
    desktopClasses = 'show-full-list-container d-none d-lg-block';
    mobileClasses = 'd-block d-lg-none';
  }

  return displayChildrenOnlyOnTablet ||
    displayChildrenOnlyOnMobile ||
    displayAlertOnlyOnMobile ? (
    <>
      <div className={desktopClasses}>
        {button}
        {renderChildren}
      </div>
      <div className={mobileClasses}>
        {displayChildrenOnlyOnMobile && children}
        {displayChildrenOnlyOnTablet && children}
        {displayAlertOnlyOnMobile && (
          <div className="input-well">
            <p>
              For more details including charts &amp; calculations, please view
              this page on a desktop.
            </p>
          </div>
        )}
      </div>
    </>
  ) : (
    <div className="show-full-list-container">
      {button}
      {renderChildren}
    </div>
  );
};

export default ShowHideButton;

ShowHideButton.propTypes = {
  children: PropTypes.node.isRequired,
  buttonText: PropTypes.string,
  displayChildrenOnlyOnTablet: PropTypes.bool,
  displayChildrenOnlyOnMobile: PropTypes.bool,
  displayAlertOnlyOnMobile: PropTypes.bool,
};
